module.exports = __webpack_public_path__ + "static/media/how-works-en.9faee504.png";